<template>
  <div>
    <list
      row-key="InstanceId"
      ref="list"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getMyList"
      @reset="$refs.picker.clear()"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="请假类型">
          <el-select v-model="params.LeaveType" clearable>
            <template v-for="(i,key) in LeaveTypes">
              <el-option :key="key" :label="i.LeaveTypeName" :value="i.LeaveTypeName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="请假时间">
          <range-picker
            ref="picker"
            @change="(x)=>{params.StartDate=x.Start;params.EndDate=x.End}"
          />
        </el-form-item>
        <el-form-item label="请假时长">
          <div style="display: flex;">
            <el-input class="num-range" v-model="params.StartDuration" v-int></el-input>
            <div style="display: inline-block;width: 5px;"></div>
            <el-input class="num-range" v-model="params.EndDuration" v-int></el-input>
          </div>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="params.Status" clearable>
            <el-option label="审批中" :value="1"></el-option>
            <el-option label="已通过" :value="2"></el-option>
            <el-option label="已驳回" :value="3"></el-option>
            <el-option label="已撤销" :value="4"></el-option>
            <el-option label="通过后撤销" :value="5"></el-option>
            <el-option label="异常" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销假状态">
          <el-select v-model="params.EndStatus" clearable>
            <el-option label="待销假" value="待销假"></el-option>
            <el-option label="已销假" value="已销假"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="LeaveType" label="请假类型" min-width="90px" show-overflow-tooltip />
        <el-table-column prop="StartTime" label="开始时间" min-width="120px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.StartTime)}}</span>
            <span style="margin-left: 5px;">{{row.StartTimePart}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EndTime" label="结束时间" min-width="120px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.EndTime)}}</span>
            <span style="margin-left: 5px;">{{row.EndTimePart}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Duration" label="请假时长">
          <template slot-scope="{row}">{{row.Duration}}天</template>
        </el-table-column>
        <el-table-column prop="Status" label="状态" align="center" width="90px">
          <template slot-scope="{row}">
            <span style="color: #409EFF;" v-if="row.Status==1">审批中</span>
            <span style="color: #67C23A;" v-if="row.Status==2">已通过</span>
            <span style="color: #F56C6C;" v-if="row.Status==3">已驳回</span>
            <span style="color: #909399;" v-if="row.Status==4">已撤销</span>
            <span style="color: #909399;" v-if="row.Status==5">通过后撤销</span>
            <span style="color: #F56C6C;" v-if="row.Status==6">异常</span>
          </template>
        </el-table-column>
        <el-table-column prop="EndStatus" label="销假状态" align="center" width="80px">
          <template slot-scope="{row}">
            <span v-if="row.NeedEnd=='是'">{{row.EndStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CompleteTime" label="实际结束时间" min-width="120px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.ActualEndTime)}}</span>
            <span style="margin-left: 5px;">{{row.ActualEndTimePart}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Reason" label="请假事由" min-width="200px" />
        <el-table-column prop="CompleteTime" label="附件" min-width="300px">
          <template slot-scope="{row}">
            <template v-for="(a,akey) in row.Files.split('--|--')">
              <span class="attach" :key="akey" @click="download(a)">{{a.split('--@--')[1]}}</span>
            </template>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <el-dialog title="查看图片" :width="isMB?'90%':''" :visible.sync="imgVisible" append-to-body>
      <img width="100%" :src="imgUrl" alt />
    </el-dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/wf/wfleave").default,
      leave_type_api: require("@/api/ent/leaveType").default,
      params: {
        LeaveType: "",
        StartDate: null,
        EndDate: null,
        Status: null,
        EndStatus: "",
        StartDuration: null,
        EndDuration: null,
      },
      LeaveTypes: [],
      isMB: this.$store.state.isMB,
      imgVisible: false,
      imgUrl: "",
    };
  },
  mounted() {
    this.leave_type_api.list({}).then((res) => {
      this.LeaveTypes = res.Data;
    });
  },
  methods: {
    download(item) {
      var url = item.split("--@--")[0];
      var name = item.split("--@--")[1];
      var ext_list = name.split(".");
      var ext = ext_list[ext_list.length - 1];
      console.log("name", name);
      console.log("ext", ext);

      if (ext == "jpg" || ext == "png" || ext == "jpeg") {
        this.imgUrl = location.protocol + "//" + location.host + "/api" + url;
        console.log("imgUrl", this.imgUrl);
        this.imgVisible = true;
        return;
      }
      if (ext == "pdf") {
        if (this.chrome) {
          var href = location.protocol + "//" + location.host + "/api" + url;
          window.open(href, "_blank");
          return;
        }
      }

      const elink = document.createElement("a");
      elink.download = name;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + url;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
  },
};
</script>
<style lang="scss">
.num-range {
  width: 90px;
  .el-input__inner {
    width: 90px !important;
  }
}
.attach {
  color: #409eff !important;
  cursor: pointer;
}
.attach:not(:last-child)::after {
  content: "、";
}
</style>